import { Component, OnInit } from '@angular/core';
import {GlobalDataService, ResetAuthToken} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {Router} from '@angular/router';
import {ViewOrdersService} from '../view-orders.service';

@Component({
  selector: 'app-view-orders',
  templateUrl: './view-orders.component.html',
  styleUrls: ['./view-orders.component.css'],
  providers: [ViewOrdersService]
})
export class ViewOrdersComponent implements OnInit {
  private gridData: any;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ViewOrdersService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.componentService.getData().then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.gridData = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  editHandler(event) {
    this.router.navigate(['/manage/order'], { queryParams: { id: event.dataItem.id } });
  }

}



// WEBPACK FOOTER //
// ./src/app/view-orders/view-orders.component.ts